/* global process */
import axios from 'axios';
import { AuthService } from '@/services';

const baseURL = process.env.VUE_APP_API_VERSION === 'dev' ? process.env.VUE_APP_PDF_GENERATOR_URL : `${window.location.origin}/`;

const pdfAPI = axios.create({
  baseURL,
});

pdfAPI.defaults.headers['x-client-version'] = process.env.VUE_APP_CLIENT_VERSION;

pdfAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      AuthService.signOutUser();
    }

    return Promise.reject(error);
  },
);

export default pdfAPI;
